import Clipboard from 'clipboard'
import _ from 'lodash'
import { showToast } from '@nutui/nutui'

export function isDef(v) {
  return v !== undefined && v !== null
}
export function timeSlice10(time) {
  if (!time) return ''
  return new Date(time).getTime().toString().slice(0, 10)
}

export class Storage {
  constructor() {}
  static getLoc(key) {
    return localStorage.getItem(key) && localStorage.getItem(key) !== 'undefined'
      ? JSON.parse(localStorage.getItem(key))
      : ''
  }
  static setLoc(obj) {
    localStorage.setItem(obj.key, JSON.stringify(obj.value))
  }
  static removeLoc(key) {
    localStorage.removeItem(key)
  }
  static getSession(key) {
    return sessionStorage.getItem(key) && sessionStorage.getItem(key) !== 'undefined'
      ? JSON.parse(sessionStorage.getItem(key))
      : ''
  }
  static setSession(obj) {
    sessionStorage.setItem(obj.key, JSON.stringify(obj.value))
  }
  static removeSession(key) {
    sessionStorage.removeItem(key)
  }
}
/**
 *
 * @param {*} FormObj 要插入的表单
 * @param {*} dataMap 插入的数据队列
 *                    > Key要插入的内容
 *                    > Option属性
 *                    > data 数据
 */
export function findKeyToFillOption(FormObj, dataMap) {
  Object.values(FormObj).forEach((e) => {
    if (e.key in dataMap) {
      const curFillKey = dataMap[e.key].fillKey
      e[curFillKey] = dataMap[e.key].list
    }
  })
}

export function dataURLToImage(dataURL) {
  return new Promise((resolve) => {
    const img = new Image()
    img.onload = () => resolve(img)
    img.src = dataURL
  })
}

export function canvastoFile(canvas, type, quality) {
  return new Promise((resolve) => canvas.toBlob((blob) => resolve(blob), type, quality))
}

export const fileToDataURL = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader()
    reader.onloadend = (e) => resolve(e.target.result)
    reader.readAsDataURL(file)
  })
}

/**
 *
 * @param {*} formVal 表单值
 * @param {*} formContent 表单项目
 */
export function validator(formVal, formContent) {
  const tips = {}
  let error = []
  let valid = true
  formContent.forEach((e) => {
    // 有relateBy
    if (e.relateBy && !e.relateBy(formVal)) {
      return false
    }
    const val = formVal[e.key]
    if (!e.rules) return false
    // 判断是否为空
    if (
      e.rules[0].required &&
      (val === '' || val === null || (Array.isArray(val) ? val.length === 0 : false))
    ) {
      tips[e.key] = e.rules[0].message
      valid = false
    } else {
      e.rules.forEach((re) => {
        if (!re.regex) return false
        if (!re.regex.test(val)) {
          valid = false
          if (!tips[e.key]) {
            tips[e.key] = re.message
          }
        } else if (re.validator && !re.validator(e, val)) {
          tips[e.key] = re.message
        }
      })
    }
  })
  return { tips, error, valid }
}

export function formValidatorReset(formErrorTip, tips) {
  Object.keys(formErrorTip).forEach((e) => {
    if (!tips[e]) {
      delete formErrorTip[e]
    }
  })
  Object.entries(tips).forEach((obj) => {
    formErrorTip[obj[0]] = obj[1]
  })
}

export const toCopy = () => {
  let clipboard = new Clipboard('.copy')
  clipboard.on('success', (e) => {
    showToast.success('复制成功', { icon: () => null, 'custom-class': 'copy-toast' })
    // 释放内存
    clipboard.destroy()
  })
  clipboard.on('error', (e) => {
    // 不支持复制
    console.log('该浏览器不支持自动复制', e)
    // 释放内存
    clipboard.destroy()
  })
}
import { getCurrentInstance } from 'vue'
/**
 * @param {*} proxy
 * @param {*} type 事件类型
 * @param {*} tip 提示文字
 * @param {*} option 选项
 */
export const commonToast = (proxy, type, tip, option = {}) => {
  const iconDic = {
    success: proxy.$DynamicImg('common_success_toast.svg')
    // 'error':,
    // 'warn':,
  }
  proxy.$toast[type](tip, {
    icon: iconDic[type],
    iconSize: 32,
    duration: 2000,
    ...option
  })
}

export const DynamicImg = (filename) => {
  return new URL(`../assets/img/${filename}`, import.meta.url).href
}

export function getUrlParam(name) {
  return (
    decodeURIComponent(
      (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [
        ,
        ''
      ])[1].replace(/\+/g, '%20')
    ) || null
  )
}

// query序列化
export const p2q = (param) => {
  if (param == undefined) return ''
  let query = ''
  Object.keys(param).forEach((e, i) => {
    query += `${i === 0 ? '?' : '&'}${e}=${param[e]}`
  })
  return query
}

// 获取queryObj
export function getQueryObj(url) {
  let arr = decodeURIComponent(url).split('?')[1].split('#')[0].split('&')
  const resObj = {}
  arr.forEach((item) => {
    let [key, value = ''] = item.split('=')
    resObj[key] = value
  })
  return resObj
}

// 是否为移动端
export function isMobile() {
  if (
    window.navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
  ) {
    return true // 移动端
  } else {
    return false // PC端
  }
}

/**
 * @description 防抖函数
 * @param {*} fun
 * @param {*} wait
 * @returns
 */
export const debounce = (fun, wait) => {
  let timeout
  return function () {
    if (timeout) {
      clearTimeout(timeout)
    }
    //第一次执行任务，timeout是null，此时callNow是true，需要立即执行
    let callNow = !timeout
    timeout = setTimeout(() => {
      timeout = null
    }, wait)
    if (callNow) {
      fun.apply(this)
    }
  }
}
/**
 * @description 格式化字典
 * @returns
 */
export const formatDictionary = (list) => {
  return list.map((v) => ({
    value: v.dictionaryCode,
    text: v.dictionaryNameCn
  }))
}
/**
 * 数组对象去重
 * @param {Array}  arr    要去重的数组对象
 * @param {String} key    对象中的唯一标识符
 *
 * @return {Array} 去重后的数组
 */
export function arrayObjDeWeight(arr, key) {
  let newArr = JSON.parse(JSON.stringify(arr))
  const obj = {}
  newArr = newArr.reduce((item, next) => {
    if (typeof key === 'object') {
      if (!obj[next[key[0]]] || !obj[next[key[1]]]) {
        obj[next[key[0]]] = item.push(next)
        obj[next[key[1]]] = true
      }
    } else {
      if (!obj[next[key]]) {
        obj[next[key]] = item.push(next)
      }
    }
    return item
  }, [])
  return newArr
}
export const hasPermission = (route, roles) => {
  if (route.meta && route.meta.code) {
    return roles.some((role) => route.meta.code.indexOf(role.id) >= 0)
  } else {
    return true
  }
}

/*
  过滤路由表 返回符合用户角色的路由
  @param Router 路由
  @param roles 用户角色
*/
export const filterRouter = (reouter, roles) => {
  let filterRouter = reouter.filter((route) => {
    if (hasPermission(route, roles)) {
      return true
    }
    return false
  })
  return filterRouter
}

export const isPhoneNumber = (phoneNumber) => {
  const regex = /^1[3-9]\d{9}$/
  return regex.test(phoneNumber)
}

// 复制文本到粘贴板
export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text)
    showToast.success('复制成功', { icon: () => null, 'custom-class': 'copy-toast' })
  } catch (err) {
    console.error('无法复制文本: ', err)
  }
}
/*
 code -> 数据字典的 code 码
 vals -> 需要过滤数据字典项的值
 combine = {comVal:'拼接字符串',location:'before',sep:'#'}    字典值是否需要拼接其他字典值
 comVal(可以填写需要拼接字符串/ 填写'@parent'则拼接父级字典值)
 location(拼接值位置before在原字典值前，after在原字典值后,默认为after)
 sep(拼接的字典值之间是否需要其他字符区隔)
 **/
export const createDictList = (code, vals = [], combine = {}) => {
  const lang = "en"
  const dict = JSON.parse(localStorage.getItem('dict')) || []
  vals = Array.isArray(vals) ? vals : [vals]
  let res = []
  if (_.isObject(dict) && Array.isArray(dict[code])) {
    let comVal = ''
    let sepChar = ''
    let location = 'after'
    let isParent = false
    if (combine['comVal']) {
      sepChar = combine['sep'] ? combine['sep'] : ''
      location = combine['location'] ? combine['location'] : 'after'
      if (combine['comVal'] != '@parent') {
        comVal = combine['comVal']
      } else {
        isParent = true
      }
    }
    if (('' + code).length == 8) {
      let casDic = []
      let casDicStr = ''
      if (lang == 'en') {
        casDicStr = dict[code][0]['codeEnDesc']
      } else {
        casDicStr = dict[code][0]['codeCnDesc']
      }
      // casDicStr = dict[code][0]['codeCnDesc']
      casDicStr = casDicStr.replace(/v:/g, 'v":')
      casDicStr = casDicStr.replace(/t:/g, 't":"')
      casDicStr = casDicStr.replace(/,/g, ',"')
      casDicStr = casDicStr.replace(/;/g, '"},{"')
      casDicStr = '[{"' + casDicStr + '"}]'
      casDic = JSON.parse(casDicStr)
      if (isParent) {
        let type1 = code + ''
        comVal = this.createDictText(code, type1.substring(0, 4))
      }
      res = casDic.map((x) => ({
        text: location == 'after' ? x.t + sepChar + comVal : comVal + sepChar + x.t,
        value: x.v,
        checked: false
      }))
    } else {
      for (let i = 0; i < dict[code].length; i++) {
        let jsonVal = {}
        let textVal = ''
        jsonVal = dict[code][i]
        if (isParent && jsonVal['parentId']) {
          comVal = this.createDictText(
            jsonVal['parentId'],
            (jsonVal['parentId'] + '').substring(0, 4)
          )
        }
        if (lang == 'en') {
          textVal =
            location == 'after'
              ? jsonVal['codeEnDesc'] + sepChar + comVal
              : comVal + sepChar + jsonVal['codeEnDesc']
        } else {
          textVal =
            location == 'after'
              ? jsonVal['codeCnDesc'] + sepChar + comVal
              : comVal + sepChar + jsonVal['codeCnDesc']
        }
        // textVal = location == 'after' ? jsonVal['codeCnDesc'] + sepChar + comVal : comVal + sepChar + jsonVal['codeCnDesc']
        res.push({ text: textVal, value: jsonVal['codeId'], checked: false })
      }
    }
    res = res.filter((x) => !vals.includes(x.value))
  }
  return res
}

export const createDictText = (val, code) => {
  const lang = localStorage.getItem('lang') || 'en'
  const dict = JSON.parse(localStorage.getItem('dict')) || []

  let res = ''
  if (!val) return res
  if (_.isObject(dict) && Array.isArray(dict[code])) {
    const target = dict[code].find((x) => x.codeId == val)
    if (lang == 'en') {
      res = target ? target.codeEnDesc || '' : val
    } else {
      res = target ? target.codeCnDesc || '' : val
    }
  }
  return res
}
